import React from 'react';
import { Card, CardContent, CardDescription, CardHeader, CardTitle } from '@/components/ui/card';
import { Button } from '@/components/ui/button';
import { AlertTriangle, ArrowRight } from 'lucide-react';
import { useNavigate } from 'react-router-dom';

const OAuthCallbackInfo = () => {
  const navigate = useNavigate();

  return (
    <div className="min-h-screen bg-background flex items-center justify-center px-4">
      <Card className="max-w-md w-full">
        <CardHeader className="text-center">
          <AlertTriangle className="h-12 w-12 text-amber-600 mx-auto mb-4" />
          <CardTitle className="text-amber-600">OAuth Processing Notice</CardTitle>
          <CardDescription>
            OAuth authentication is handled through our secure server infrastructure
          </CardDescription>
        </CardHeader>
        
        <CardContent className="space-y-4">
          <div className="text-sm text-muted-foreground space-y-2">
            <p>
              <strong>For users:</strong> Please initiate social platform connections using the "Connect" 
              buttons in your dashboard.
            </p>
            <p>
              <strong>For developers:</strong> OAuth callbacks are processed at:
            </p>
            <code className="block bg-muted p-2 rounded text-xs break-all">
              https://ifkrklrmsjszdloohxvx.supabase.co/functions/v1/oauth-callback
            </code>
          </div>
          
          <div className="flex flex-col space-y-2">
            <Button onClick={() => navigate('/dashboard')} className="w-full">
              <ArrowRight className="h-4 w-4 mr-2" />
              Go to Dashboard
            </Button>
            <Button variant="outline" onClick={() => navigate('/')} className="w-full">
              Back to Home
            </Button>
          </div>
        </CardContent>
      </Card>
    </div>
  );
};

export default OAuthCallbackInfo;